import React from 'react';
import * as style from './style.css';
import { Body1 } from '@cian/ui-kit';
import { ITransportPointExtended } from '../../../../../../../types/newbuildingsCompare';
import { TransportPointIcon } from '../../shared/TransportPointIcon';
import { transportTypeIconMapper } from '../../shared/transportIcons';

interface ITransportPointRowProps {
  item: ITransportPointExtended;
}

export const TransportPointRow = ({ item }: ITransportPointRowProps): React.JSX.Element => (
  <span className={style['transport-row']}>
    <TransportPointIcon className={style['icon-container']} point={item} />
    <Body1 color="text-primary-default">{item.name}</Body1>
    {transportTypeIconMapper(item.transportDistance?.transportType)}
    <Body1 color="text-secondary-default">{item.transportDistance?.distance}</Body1>
  </span>
);
